import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataSiteEngineer } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_SITE_ENGINEER = defineMasterdataEntity<MasterdataSiteEngineer>({
  name: 'site-engineer',
  responseKey: 'siteEngineers',
  displayWith: (s) => keyName(s.key, s.name),
  defaultFilter: ACTIVE_ONLY,
  icon: 'fa-regular fa-helmet-safety',
  title: 'Bauleitersuche',
  label: 'Bauleiter',
  placeholder: 'Bauleiter suchen...',
  columns: [
    {
      label: 'Bauleiter',
      type: 'entity',
      icon: 'fa-regular fa-helmet-safety',
      value: (e) => keyName(e.key, e.name),
    },
    { label: 'Schlüssel', value: (e) => e.key },
    { label: 'Bezeichnung', value: (e) => e.name },
    { label: 'Aktiv', value: (e) => (e.active ? 'Ja' : 'Nein') },
  ],
});
